<div class="top-pan-3-pic hoh">
  <div [ngStyle]="parent.TopPanTextStyle()" class="top-pan-text">
    リクエストされたページが見つかりませんでした。<br />
    404クラスのエラーとみなして、その旨をお問い合わせください。
  </div>
</div>
<div class="top-pan-3"></div>
